VegasShop.Cart = {
	defaultParams: [
		{
			name: '_token',
			value: App.csrf
		}
	],

	requestPost: function (route, params = {}, callback = {}) {
		let options = [];

		for (let i in this.defaultParams)
			options.push(this.defaultParams[i]);

		if (params) {
			for (let name in params) {
				options.push({name: name, value: params[name]});
			}
		}

		if ('beforeSend' in callback) {
			callback.beforeSend();
		}

		return $.post('/cart/' + route, options, function (data) {
			if ('afterSend' in callback) {
				callback.afterSend(data);
			}

			let callbacks = ['afterAdd', 'afterChange', 'afterDel'];
			for (let c in callbacks) {
				if (callbacks[c] in callback) {
					callback[callbacks[c]](data);
				}
			}
		});
	},

	requestAdd: function (params, callback = {}) {
		callback.afterAdd = function (data) {
			if (!data.error) {
				VegasShop.Cart.total(data);
				VegasShop.Cart.popup(data.product.title, 'added');

				$('.vg-shop-prd[data-id="' + data.product.id + '"]').addClass('in-cart');
			}
		};

		this.requestPost('add_product', params, callback);
	},

	requestChange: function (params, callback = {}) {
		callback.afterChange = function (data) {
			if (!data.error) {
				VegasShop.Cart.total(data);
			}
		};

		this.requestPost('change_product', params, callback);
	},

	requestDel: function (params, callback = {}) {
		callback.afterDel = function (data) {
			if (!data.error) {
				VegasShop.Cart.total(data);
				VegasShop.Cart.popup(data.product.title, 'removed');

				$('.vg-shop-prd[data-id="' + data.product.id + '"]').removeClass('in-cart');
			}
		};

		this.requestPost('del_product', params, callback);
	},

	add: function ($self, callback = {}) {
		let $product = $self.closest('[data-cart=product]');
		let params = {
			id: $self.data('id') || $product.data('id'),
			cnt: $product.find('input[name=cnt]').val() || 1
		};

		this.requestAdd(params);
	},

	change: function ($self, appendParams, callback = {}) {
		let $product = $self.closest('[data-cart=product]');

		let params = {
			id: $product.data('id') || false,
			pivot_id: $product.data('pivot_id') || false,
			cnt: $product.find('input[name=cnt]').val() || 1,
			get_products_totals: true,
		};

		params = $.extend({}, params, appendParams || {});

		this.requestChange(params);
	},

	remove: function ($self, callback = {}) {
		let $product = $self.closest('[data-cart=product]');

		this.requestDel({
			id: $product.data('id') || false,
			pivot_id: $product.data('pivot_id') || false,
		}, callback);
	},

	popup: function (title, status = '') {
		let text;

		if (status === 'added') {
			text = title + '<br> добавлен в корзину'
		} else {
			text = title + '<br> убран из корзины'
		}

		$.toast({
			text: text,
			position: 'top-right',
			icon: 'success',
			stack: 5
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart][data-counter=products-count]').attr('data-cnt', data.products_count);
		}

		if (typeof data.sums !== 'undefined') {
			if (typeof data.sums.sum_products !== 'undefined')
				$('[data-cart][data-counter=sum-products]').html(output_roubles(data.sums.sum_products));

			if (typeof data.sums.sum_delivery !== 'undefined')
				$('[data-cart][data-counter=delivery]').html(
					data.sums.sum_delivery > 0 ? output_roubles(data.sums.sum_delivery) : 'бесплатно'
				);

			if (typeof data.sums.sum !== 'undefined')
				$('[data-cart][data-counter=sum]').html(output_roubles(data.sums.sum));
		}

		this.totalProducts(data);
	},

	totalProducts: function (data) {
		if (typeof data.products_totals !== 'undefined') {
			for (let i in data.products_totals) {
				let item = data.products_totals[i];
				let $price_total = $('.cart-prd[data-pivot_id="' + item.pivot_id + '"]').find('.price-total');

				if ($price_total.length) {
					$price_total.text(output_roubles(item.price_total));
				}
			}
		}
	},

	updateOrderData: function (appendParams) {
		let params = $("#form-order").serializeArray();

		if (typeof appendParams !== 'undefined') {
			for (let name in appendParams) {
				params.push({
					name: name, value: appendParams[name]
				});
			}
		}

		$.get('/cart/get_totals', params, function (data) {
			VegasShop.Cart.total(data);
		});
	}
};

$(document).ready(function () {
	$(document).on('click', '[data-cart=add]', function () {
		VegasShop.Cart.add($(this));
		return false;
	});

	$(document).on('click', '.vg-shop-order [data-cart=remove]', function () {
		VegasShop.Cart.remove($(this), {
			afterSend: function (data) {
				var $p = $('.cart-table [data-cart="product"][data-id="' + data.product.id + '"]');
				$p.fadeOut('fast', function () {
					$p.remove();

					let rowsCount = parseInt($('.cart-table [data-cart=product]:visible').length) - 1;

					location.reload()
				});
			}
		});

		return false;
	});
	$(document).on('click', '.vg-shop-order [data-cart=change-items]', function () {
		let $self = $(this),
			$cartPrd = $(this).closest('.cart-prd'),
			$input = $cartPrd.find('input[name=cnt]'),
			sign = $self.data('sign'),
			cnt = $input.val() || 1;

		if (sign === 'minus') {
			if (cnt > 1) cnt--;
		} else {
			cnt++;
		}

		$input.val(cnt);

		var formParams = $formOrder.serializeArray();
		var params = {
			pivot_id: $cartPrd.data('pivot_id'),
			cnt: cnt,
			get_all_sums: true,
			get_products_totals: true,
		};
		for(var p in formParams) {
			params[formParams[p].name] = formParams[p].value;
		}

		VegasShop.Cart.requestChange(params, {
			afterSend: function (data) {
				VegasShop.Cart.total(data);
			}
		});

		return false;
	});

	let $formOrder = $("#form-order");

	$formOrder.find('[name=delivery_id]').change(function () {
		VegasShop.Cart.updateOrderData();
	});

	$formOrder.find('[data-toggle=tab-delivery]').on('click', function () {
		let id = $(this).attr('for'),
			$container = $(this).closest('.vg-shop-order').find('.tab-delivery-content');

		$container.find('.active').removeClass('show active');

		let $currentDelivery = $container.find('#' + id);
		$currentDelivery.addClass('show active');

		$('.tab-delivery-content .toggle-required').removeAttr('required');
		$currentDelivery.find('.toggle-required').attr('required', 'required');
	});

	$formOrder.find('.delivery-type-radio').eq(0).trigger('change');
});
